import domainsStore from "../stores/data/domainsStore.js";

function updateDomain({ domain }) {
	domainsStore.updateDomain(domain);
}

export default {
	updateDomain,
};
